export default "__VITE_ASSET__sd9tD40G__"